import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { GoogleLogin, type CredentialResponse } from '@react-oauth/google'
import { useAuth } from '../../hooks/useAuth'

interface GoogleButtonProps {
  mode: 'signin' | 'signup'
  onSuccessCallback?: () => void
}

export default function GoogleButton({ mode, onSuccessCallback }: GoogleButtonProps) {
  const { googleLogin } = useAuth()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  const handleSuccess = async (credentialResponse: CredentialResponse) => {
    setError(null)
    try {
      if (!credentialResponse.credential) {
        throw new Error('No credential received from Google')
      }
      await googleLogin(credentialResponse.credential)
      if (onSuccessCallback) {
        onSuccessCallback()
      } else {
        navigate('/')
      }
    } catch (err) {
      console.error('Google login error:', err)
      setError('Failed to sign in with Google. Please try again.')
    }
  }

  const handleError = () => {
    console.error('Google OAuth error')
    setError('Google sign in was cancelled or failed.')
  }

  return (
    <div className="flex flex-col items-center">
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        text={mode === 'signin' ? 'signin_with' : 'signup_with'}
        shape="pill"
        theme="outline"
        size="large"
        width="320"
      />
      {error && <p className="mt-2 text-xs text-red-600">{error}</p>}
    </div>
  )
}
